import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, BASE } from "@/lib/api";
import { ResultBars } from "@/components/tss/ResultBars";
import { PageHeader } from "@/pages/admin/shared";

export default function Results() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const load = () => api.get("/admin/results").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);
  const total = data.reduce((s, c) => s + c.total, 0);

  return (
    <div data-testid="admin-results">
      <PageHeader title="Results" sub={`${total} votes across ${data.length} categories`}>
        <a href={`${BASE}/api/admin/export.csv`} data-testid="export-csv-btn" className="inline-flex items-center gap-2 rounded-full bg-maroon px-5 py-2.5 font-semibold text-ivory">
          <Download className="h-4 w-4" /> Export CSV
        </a>
      </PageHeader>
      <div className="grid gap-4 xl:grid-cols-2">
        {data.map((c) => <ResultBars key={c.id} category={c} />)}
      </div>
    </div>
  );
}
